export const navigationOptions = {
  headerMode: "none" as const,
};
